import { render } from "./Home.vue?vue&type=template&id=c3e52a3a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script